import React from "react";
import {
  Trophy,
  Timer,
  Users,
  BarChart,
  Video,
  Calendar,
  Ticket,
  Activity,
} from "lucide-react";
import IndustryPageTemplate from "../components/IndustryPageTemplate";

const SERVICE_OFFERINGS = [
  {
    title: "Sports Management Platforms",
    description: "Build systems for team, league, and tournament management",
    icon: Trophy,
  },
  {
    title: "Live Scoring & Stats",
    description: "Real-time scoring, statistics, and performance tracking",
    icon: Timer,
  },
  {
    title: "Fan Engagement Apps",
    description: "Create immersive fan experiences with social features",
    icon: Users,
  },
  {
    title: "Video & Broadcasting",
    description: "Live streaming and video-on-demand platforms",
    icon: Video,
  },
  {
    title: "Ticketing Systems",
    description: "Event ticketing with seat selection and payment",
    icon: Ticket,
  },
  {
    title: "Athlete Analytics",
    description: "Performance analytics and training optimization tools",
    icon: Activity,
  },
  {
    title: "Event Management",
    description: "Sports event planning and coordination platforms",
    icon: Calendar,
  },
  {
    title: "Fantasy Sports",
    description: "Build fantasy sports platforms with live scoring",
    icon: BarChart,
  },
];

const STATS = [
  { value: "100+", label: "Sports Apps" },
  { value: "50M+", label: "Fans Engaged" },
  { value: "10K+", label: "Events Managed" },
  { value: "Real-time", label: "Stats" },
];

const SportsIndustryPage = () => {
  return (
    <IndustryPageTemplate
      industrySlug="sports"
      industryTitle="Sports"
      industrySubtitle="& Entertainment"
      heroDescription="Elevating sports experiences with innovative fan engagement platforms, live scoring systems, and sports management solutions that connect athletes, teams, and fans."
      themeColor="#ef4444"
      themeColorLight="#f87171"
      themeGradient="linear-gradient(135deg, #7f1d1d 0%, #b91c1c 50%, #ef4444 100%)"
      HeroIcon={Trophy}
      stats={STATS}
      serviceOfferings={SERVICE_OFFERINGS}
      heroImage={
        "https://images.unsplash.com/photo-1575918814754-79b567455645?q=80&w=2071&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
      }
    />
  );
};

export default SportsIndustryPage;
